import { FilterSettings } from 'components/tables/Table.interfaces';
import {
	Subscription,
	SubscriptionStatus,
} from 'domain/subscription/interfaces/Subscription';

export const columnFilters: FilterSettings<Subscription> = {
	treatGroupsAsSingle: true,
	groups: [
		{
			columnId: 'status',
			filters: [
				{
					text: 'Active',
					value: [
						SubscriptionStatus.Active,
						SubscriptionStatus.Ordered,
					],
					selected: true,
				},
				{
					text: 'Inactive',
					value: [
						SubscriptionStatus.Canceled,
						SubscriptionStatus.Expired,
					],
					selected: false,
				},
				{
					text: 'All',
					value: undefined,
					selected: false,
				},
			],
		},
	],
};
